import React from 'react';
import { useTranslation } from 'react-i18next';

import { DemandStatus, RecruiterDTO } from 'entities/demand';

import { LinkButton } from 'shared/ui/LinkButton';
import styles from './DemandItem.module.scss';

export interface IDemandItemProps {
  status: DemandStatus;
  expiresIn: number;
  recruiter?: RecruiterDTO;
  editLinkHref: string;
  hideEditButton?: boolean;
}

const DemandItem: React.FC<IDemandItemProps> = (props) => {
  const { status, expiresIn, recruiter, editLinkHref, hideEditButton } = props;

  const { t } = useTranslation('Demand');
  const statusText = t(`DemandList.item.status.${status.toLowerCase()}`, { defaultValue: '' });

  const getExpiresText = (): string => {
    if (expiresIn < 0) {
      return t('DemandList.item.desirableDate.additionalText.failed');
    }

    return t('DemandList.item.desirableDate.additionalText', { count: expiresIn });
  };

  const getRecruiterText = (): string => {
    const name = recruiter
      ? `${recruiter.firstName} ${recruiter.lastName}`
      : t('DemandList.item.recruiter.placeholder.text');

    return t('DemandList.item.recruiter.additionalText', { name });
  };

  return (
    <div className={styles.rowContainer} data-testid="demand-list-item">
      <div className={styles.status} data-testid="status">
        {statusText}
      </div>
      {status === 'ACTIVE' ? (
        <div className={styles.expiresInText} data-testid="desirable-date">
          {getExpiresText()}
        </div>
      ) : (
        <span>&nbsp;</span>
      )}
      {status === 'ACTIVE' ? (
        <div className={styles.recruiter} data-testid="recruiter">
          {getRecruiterText()}
        </div>
      ) : (
        <span>&nbsp;</span>
      )}
      {!hideEditButton && (
        <LinkButton
          buttonProps={{ variant: 'outlined' }}
          linkProps={{ to: editLinkHref, className: styles.editButton }}
        >
          {t('DemandList.item.editButton.label')}
        </LinkButton>
      )}
    </div>
  );
};

export default React.memo(DemandItem);
